import React from 'react';
import { BookOpen, FileText, X } from 'lucide-react';
import type { ManualContextNote } from '@Types/knowledge';

interface ContextChipStripProps {
  active: ManualContextNote[];
  onRemove: (contextId: string) => void;
}

export const ContextChipStrip = ({
  active,
  onRemove,
}: ContextChipStripProps) => {
  if (active.length === 0) return null;

  return (
    <div className="mb-2">
      {active.length > 1 && (
        <p className="text-[11px] text-[#768D95] mb-1">
          {active.length} attached — sent with your message for cited evidence
        </p>
      )}
      <div className="flex flex-wrap gap-1.5">
        {active.map(note => {
          const isTenant = note.scope === 'tenant';
          return (
            <div
              key={note.context_id}
              className={`group relative inline-flex items-center gap-1 pl-2 pr-1 py-1 rounded-full border text-xs ${
                isTenant
                  ? 'bg-sky-50 border-sky-200 text-sky-900'
                  : 'bg-amber-50 border-amber-200 text-amber-950'
              }`}>
              {note.item_type === 'document' ? (
                <FileText className="h-3 w-3" />
              ) : (
                <BookOpen className="h-3 w-3" />
              )}
              <span className="font-medium">{note.name}</span>
              {note.apply_mode === 'always' && (
                <span className="text-[10px] uppercase tracking-wide px-1 rounded bg-emerald-100/80 text-emerald-800">
                  Always
                </span>
              )}
              <button
                type="button"
                onClick={() => onRemove(note.context_id)}
                className="ml-0.5 p-0.5 rounded-full hover:bg-black/5"
                aria-label={`Remove ${note.name}`}>
                <X className="h-3 w-3" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
